export default {
	
	"service_1_label": {
		"en": "Gdynia City Hall",
		"pl": "Urząd Miasta Gdyni",
		"ru": "Городское Управление Гдыни",
		"ua": "Адміністрація Міста Ґдині"
	},

	"service_1_address": {
		"en": "al. Marszałka Piłsudskiego 52/54",
		"pl": "al. Marszałka Piłsudskiego 52/54",
		"ru": "ал. Маршала Пилсудского 52/54 (al. Marszałka Piłsudskiego 52/54)",
		"ua": "ал. Маршала Пілсудського 52/54 (al. Marszałka Piłsudskiego 52/54)"
	},

	"service_2_label": {
		"en": "Resident Service Centre, Riviera Shopping Centre",
		"pl": "Centrum Obsługi Mieszkańca CH Riviera",
		"ru": "Центр обслуживания горожан ТЦ Riviera",
		"ua": "Центр Обслуговування Мешканців Торговий Дім Riviera"
	},

	"service_2_address": {
		"en": "ul. Kazimierza Górskiego 2",
		"pl": "ul. Kazimierza Górskiego 2",
		"ru": "ул. Казимежа Гурскего 2 (ul. Kazimierza Górskiego 2)",
		"ua": "вул. Казімєжа Гурскєго 2 (ul. Kazimierza Górskiego 2)"
	},

	"service_3_label": {
		"en": "Gdynia Center for Entrepreneurship Support",
		"pl": "Gdyńskie Centrum Wspierania Przedsiębiorczości",
		"ru": "Центр поддержки бизнеса в Гдыне",
		"ua": "Центр підтримки бізнесу в Гдині"
	},
	
	"service_3_address": {
		"en": "ul. 10 Lutego 24",
		"pl": "ul. 10 Lutego 24",
		"ru": "ul. 10 Lutego 24",
		"ua": "ul. 10 Lutego 24"
	},

   "service_4_label": {
		"en": "Gdynia City Hall - May 3",
		"pl": "Urząd Miasta Gdyni - 3 Maja",
		"ru": "Городское Управление Гдыни - 3 Мая",
		"ua": "Адміністрація Міста Ґдині - 3 Травня"
	},
	
	"service_4_address": {
		"en": "ul. 3 Maja 27/31",
		"pl": "ul. 3 Maja 27/31",
		"ru": "ul. 3 Maja 27/31",
		"ua": "ul. 3 Maja 27/31"
	},
}